import React, { Component } from "react";
import { Link } from "react-router";

class NetworkBenefits extends Component {
    render() {
        const { imageContent, bannerContent } = this.props;
        return (
            <section className="membership-info-background-image">
               <div className="mask--brand-muted-strong">
                   <div className="container">
                       <div className="row">
                           <div className="col-xs-12 col-md-6">
                               <ul className="membership-benefits">
                                   {
                                       imageContent.map( ( _img, index ) => {
                                           return (
                                               <li key={ index } className="row">
                                                   <span className="col-xs-3 col-sm-2 icon-benefits"><img src={ _img.image } alt="Membership benefits month icon" /></span>
                                                   <span className="col-xs-9 col-sm-10 label-benefits">{ _img.content }</span>
                                               </li>
                                           )
                                       } )
                                   }
                               </ul>
                           </div>
                           <div className="col-xs-12 col-md-6 padding-none">
                               <div className="box mask--secondary-reg">
                                   <h5 className="h5">{ bannerContent.heading }</h5>
                                   <h6 className="h6 ">{ bannerContent.sub_heading }</h6>
                                   <p className="p-tag">{ bannerContent.paragraph_1 }</p>
                                   <p className="p-tag">{ bannerContent.paragraph_2 }</p>
                                   <p className="p-tag">{ bannerContent.paragraph_3 }</p>
                                   <Link className="btn btn-primary" to='/testimonials'>
                                       <span className="label">View testimonials</span>
                                       <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
                                   </Link>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
            </section>

        );
    };
}

export default NetworkBenefits;



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/NetworkBenefits.js